import React from 'react';
import { apiRequest } from '../actions/apiActions';
import { showLoading, hideLoading, addUiMsg } from '../actions/uiActions';
import { apiUrls, apiVersion } from '../../apiUrls';
import { GET_AUTH, PROCESS_AUTH, AUTH_ERROR } from '../actions/authActions';
import { getCurrentUserInfo } from '../actions/currentUserActions';
import { FormattedMessage } from 'react-intl';
import { errorDisplay } from '../../utilities/general';
import { messageTypes } from '../../components/ui/AlertMessage';
import { getSysParams } from '../actions/systemActions';

/**
 * Middleware to get the auth token
 * @param {object} action - The action triggered by the action creator
 * @fires dispatch#showLoading - Triggers the showing of the loader bar
 * @fires dispatch#apiRequest - Starts api request to retrieve the auth token
 */
export const getAuth = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === GET_AUTH) {
    const body = {
      username: action.auth.username,
      password: action.auth.password,
    };
    const meta = {
      method: 'POST',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].login,
      onSuccess: PROCESS_AUTH,
      onError: '',
      auth: '',
      body: body,
    };
    dispatch(showLoading());
    dispatch(apiRequest(body, meta));
  }
};

/**
 * Middleware to stop the loader bar once the auth token has been retrieved
 * @param {object} action -The action triggered by the action creator
 * @fires dispatch#hideLoading - Hides the loader bar
 */
export const processAuth = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_AUTH) {
    dispatch(getCurrentUserInfo());
    dispatch(getSysParams());
    dispatch(hideLoading());
  }
};

/**
 * Middleware to process if an error occurs during the auth request
 * @param {object} action -The action triggered by the action creator
 * @fires dispatch#hideLoading - Hides the loader bar
 */
export const authError = (store) => (next) => (action) => {
  next(action);
  if (action.type === AUTH_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="authMiddleware.authErrorText"
          defaultMessage="There was an error"
          description="authentication failed"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

export const authMdl = [getAuth, authError, processAuth];
